export const firebaseConfig = {
  apiKey: 'AIzaSyBVClOKPEUth1HcHcd-qRVAv_l97ywtPrs',
  authDomain: 'authenticateforapps.firebaseapp.com',
  projectId: 'authenticateforapps',
  storageBucket: 'authenticateforapps.appspot.com',
  messagingSenderId: '57680612991',
  appId: '1:57680612991:web:cfc648150c2a0fa65c794a',
  measurementId: 'G-2LQFL7WCPQ',
};

export const adminEmail = 'ligus.konstantin@gmail.com';
